<template>

  <b-modal
    v-model="localIsVisible"
    size="md" 
    hide-footer
    @cancel="onCancel"
  >
    <b-card title="Crear laboratorio Clinico">
      <validation-observer v-slot="{ invalid }" ref="observer">
        <b-form @submit.prevent="submitForm">
          <b-form-group label-for="codigo">
            <label>Código: <span class="text-danger">*</span></label>
            <validation-provider
              #default="{ errors }"
              name="codigo"
              rules="required"
            >
              <b-form-input
                id="codigo"
                :state="errors.length > 0 ? false : null"
                v-model="laboratorio.codigo"
                type="text"
              ></b-form-input>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-form-group>
            <label>Descripcion: <span class="text-danger">*</span></label>
            <validation-provider
              #default="{ errors }"
              name="nombre"
              rules="required"
            >
              <b-form-input
                id="nombre"
                :state="errors.length > 0 ? false : null"
                v-model="laboratorio.descripcion"
                type="text"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <b-form-group label-for="precioneto">
            <label>Precio: <span class="text-danger">*</span></label>
            <validation-provider
              #default="{ errors }"
              name="precioneto"
              rules="required"
            >
              <b-form-input
                id="precioneto"
                :state="errors.length > 0 ? false : null"
                v-model="laboratorio.precioNeto"
                type="text"
                @keypress="(e)=> numberDecimal(e, 4, 4)"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <b-form-group label-for="establecimiento">
            <label>
              Establecimiento: <span class="text-danger">*</span>
            </label>
            <validation-provider
              #default="{ errors }"
              name="establecimiento"
              rules="required"
            >
              <v-select
                id="establecimiento"
                v-model="laboratorio.establecimiento"
                placeholder="Buscar por establecimiento."
                :options="establecimientosOpts"
                :reduce="(option) => option.value"
                label="text"
                class="d-inline-block w-100"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <b-form-group label-for="area">
            <label>
              Areas Analisis: <span class="text-danger">*</span>
            </label>

            <validation-provider
              #default="{ errors }"
              name="area"
              rules="required"
            >
              <v-select
                id="area"
                v-model="laboratorio.area"
                placeholder="Buscar por area."
                :options="areasOpts"
                :reduce="(option) => option.value"
                label="text"
                class="d-inline-block w-100"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <b-form-group label="Estado:" label-for="estado-switch">
            <b-form-checkbox
              id="estado-switch"
              v-model="laboratorio.estado"
              value="1"
              unchecked-value="0"
              switch
            />
          </b-form-group>

          <b-button 
            type="submit" 
            variant="primary" 
            :disabled="invalid"
          >
            Crear laboratorio
          </b-button>
        </b-form>
      </validation-observer>
    </b-card>
  </b-modal>
  
</template>

<script>
import axios   from "axios";
import rutas   from "@/assets/utils/rutas.json";
import { comprobarPermisos, numberDecimal } from "@/shared/helpers";
import vSelect from "vue-select";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {

  name: "CrearLaboratorio",

  components: {
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },

  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      numberDecimal,
      localIsVisible: false,

      laboratorio: {
        id: "",
        nombre: "",
        codigo: "",
        estado: "1",
        numMax: 1,
        precio: 0,
        establecimiento: "",
        area: "",
        establecimientos: [],
        areasa: [],
      },

      establecimientosOpts: [],
      areasOpts:[]
    };
  },

  created() {
    this.fetchEstablecimientos();
    this.fetchAreaAnalisis();
    comprobarPermisos(this.$route);
  },

  methods: {

    onCancel() {
      this.localIsVisible = false;
    },
    async fetchEstablecimientos() {
      const query = `
        query {
          allEstablecimientos {
            id
            Descripcion
            uniCodigo
          }
        }
      `;

      try {
        const response = await axios.post(rutas.axios + "api", { query });

        this.establecimientosOpts = response.data.data.allEstablecimientos.map(
          (item) => ({
            value    : item.id,
            text     : item.Descripcion,
            uniCodigo: item.uniCodigo,
          })
        );

      } catch (error) {
        console.error("An error occurred while fetching the options:", error);
      }
    },

    async fetchAreaAnalisis() {
      const query = `
        query obtenerAreaAnalisis {
          allAreaslab {
            descripcion
            id
          }
        }
      `;

      try {
        const response = await axios.post(rutas.axios + "api", { query });
        this.areasOpts = response.data.data.allAreaslab.map((item) => ({
          value: item.id,
          text: item.descripcion,
        }));
      } catch (error) {
        console.error("An error occurred while fetching the options:", error);
      }
    },

    async submitForm() {

      const precioNetoFormateado = parseFloat(
        this.laboratorio.precioNeto
      ).toFixed(4);

      const query = `
        mutation crearMulLaboratorio($labsData: [LabInput!]!) {
          crearMulLaboratorio(labsData: $labsData) {
            labs {
              token
              id
            }
            status
            message
          }
        }
      `;

      const variables = {
        labsData: {
          codigo: this.laboratorio.codigo,
          descripcion: this.laboratorio.descripcion,
          valor: precioNetoFormateado,
          area: this.laboratorio.area,
          establecimiento: this.laboratorio.establecimiento,
        },
      };

      try {
        const response = await axios.post(rutas.axios + "api", { query, variables });

        if (response.data.data.crearMulLaboratorio.status === "success") {
          await this.$swal({
            icon : "success",
            title: "Éxito",
            text : "El laboratorio se creo correctamente.",
          });

          // this.$router.push({ name: "consultar_cartera_examen" });
          this.$router.go(0)

        } else {
          // Manejar el caso de error
          this.$swal({
            title: "Error",
            text: response.data.data.crearAdmision.message,
            icon: "error",
            confirmButtonColor: "#089599",
          });
        }
      } catch (error) {
        await this.$swal({
          icon: "error",
          title: "Error",
          text: error.message || "Hubo un problema al crear la laboratorio.",
        });
      }
    },
  },

  watch: {
    isVisible(newValue) {
      this.localIsVisible = newValue;
    },

    localIsVisible(newValue) {
      this.$emit('update:isVisible', newValue);
    }
  }
};
</script>
